import { FC } from 'react';

import OrgSettings from '@/pages/OrgSettings';
import TeamSettings from '@/pages/TeamSettings';
import Workspace from '@/pages/WorkspaceTeams';
import { BasetenPageEnum } from '@/routes/types';
import asyncComponentLoader from '@/utils/react/loader';

const PageComponents: Partial<Record<BasetenPageEnum, FC>> = {
  [BasetenPageEnum.Workspace]: Workspace,
  [BasetenPageEnum.WorkspaceTeams]: Workspace,
  [BasetenPageEnum.TeamSettings]: TeamSettings,
  [BasetenPageEnum.Settings]: OrgSettings,
  [BasetenPageEnum.DeployModel]: asyncComponentLoader(() => import('@/pages/DeployModel')),
  [BasetenPageEnum.Model]: asyncComponentLoader(() => import('@/pages/Model')),
  [BasetenPageEnum.Chain]: asyncComponentLoader(() => import('@/pages/Chain')),
  [BasetenPageEnum.SharedEndpoint]: asyncComponentLoader(() => import('@/pages/SharedEndpoint')),
  [BasetenPageEnum.TrainingJob]: asyncComponentLoader(() => import('@/pages/Training_Legacy')),
  [BasetenPageEnum.TrainingProject]: asyncComponentLoader(() => import('@/pages/Training')),
  [BasetenPageEnum.Application]: asyncComponentLoader(() => import('@/legacy/Application')),
  [BasetenPageEnum.Class]: asyncComponentLoader(() => import('@/legacy/Class')),
  [BasetenPageEnum.Onboarding]: asyncComponentLoader(() => import('@/pages/Onboarding')),
  [BasetenPageEnum.ViewOperator]: asyncComponentLoader(
    () => import('@/legacy/Application/View/Operator'),
  ),
  [BasetenPageEnum.Playground]: asyncComponentLoader(() => import('@/pages/Playground')),
  [BasetenPageEnum.CreateSharedEndpoint]: asyncComponentLoader(
    () => import('@/pages/CreateSharedEndpoint'),
  ),
};

export default PageComponents;
